import router, { dynamicRoutes } from './router'
// 引入进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from './utils/auth'
import store from './store'


function getRoutePath(list, path) {
  let pathStr = path
  if (!list || list.length === 0) return path;
  list.some(item => {
    if (item.path.includes(path)) {
      pathStr = item.path
      return true
    } else {
      const hasPath = getRoutePath(item.children, path)
      if (hasPath) {
        pathStr = hasPath
        return true
      }
    }
  })
  return pathStr;
}

function hasPermission(path, list) {
  return list.some(menu => menu.path.includes(path))
}

let loading = false;

// 路由前置守卫：跳转前触发
router.beforeEach(async (to, from, next) => {
  // 触发前置守卫进度条开始
  NProgress.start()

  // next()
  // 动态路由刷新页面  vuex数据会重置
  // 需要在路由守卫中再次调用接口 去获取权限数据
  // 防止刷新页面时， vuex刷新数据
  // 判断是否是内部页面
  if (getToken()) {
    if (!loading) {
      await store.dispatch('user/getUserInfo')
      loading = true
      const menuList = store.state.user.menuAccess
      // 添加动态路由
      dynamicRoutes.forEach(item => {
        if (hasPermission(item.path, menuList)) {
          router.addRoute('Layout', item)
        }
      })
      const path = getRoutePath(store.state.user.limit, to.path)
      next(path)
      return
    }
    if (to.meta.requiresAuth) {
      next('/')
      return
    }
    console.log(store.state.user.firstTime, 'store');
    if (to.fullPath == '/changePass') {
      if (store.state.user.firstTime) {
        next()
        return
      } else {
        next('/')
        return
      }
    } else {
      if (store.state.user.firstTime) {
        next('/changePass')
        return
      } else {
        if (to.path === '/') {
          const path = getRoutePath(store.state.user.limit, to.path)
          console.log(path, 'path');
          next({ path, replace: true })
        } else {
          next()
        }
      }
    }
  } else {
    if (to.meta.requiresAuth) {
      loading = false
      next()
    } else {
      next('/login')
    }
  }
})


// 路由后置守卫
router.afterEach((to, from) => {
  NProgress.done()
})
